import React from "react";
import { ExternalLink, ArrowRight, CalendarCheck } from "lucide-react";

import { tr, localeTag } from "../i18n";
const AVAIL = {
  available_de: { label: "Available to German residents", cls: "bg-emerald-50 text-emerald-800 ring-emerald-200" },
  uk_only: { label: "UK residents only", cls: "bg-[#0b1f3a]/5 text-[#0b1f3a]/70 ring-[#0b1f3a]/15" },
  to_be_checked: { label: "Eligibility for German residents to be confirmed", cls: "bg-[#f6f2e9] text-[#8a6d2f] ring-[#c2a15a]/40" },
};

export const fmtRate = (r) => `${r.toFixed(2)}% p.a.`;
export const fmtTerm = (m) => (m === 12 ? tr("1 year") : m % 12 === 0 ? tr("{n} years", { n: m / 12 }) : tr("{n} months", { n: m }));
const fmtMin = (n) => `£${n.toLocaleString("en-GB")}`;
const fmtDate = (d) => new Date(d).toLocaleDateString(localeTag(), { day: "numeric", month: "short", year: "numeric" });

export default function OfferCard({ o, onRequest }) {
  const a = AVAIL[o.germany_availability];
  return (
    <article data-testid={`offer-card-${o.id}`}
      className="group flex flex-col rounded-2xl bg-white ring-1 ring-[#0b1f3a]/10 p-6 shadow-sm hover:shadow-xl hover:shadow-[#0b1f3a]/5 hover:-translate-y-0.5 transition-[box-shadow,transform] duration-300">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          {o.product_url ? (
            <a href={o.product_url} target="_blank" rel="noopener noreferrer" data-testid={`offer-link-${o.id}`}
              className="inline-flex items-center gap-1.5 font-display text-[20px] text-[#0b1f3a] hover:text-[#c2a15a] transition-colors">
              {o.bank} <ExternalLink size={15} className="shrink-0" />
            </a>
          ) : (
            <span className="font-display text-[20px] text-[#0b1f3a]">{o.bank}</span>
          )}
          <p className="text-[13px] text-[#0b1f3a]/55 mt-1 leading-snug">{tr(o.product_name)}</p>
        </div>
        <span className="shrink-0 rounded-full bg-[#0b1f3a] text-[#c2a15a] text-[12px] font-medium px-3 py-1">{fmtTerm(o.term_months)}</span>
      </div>

      <p data-testid={`offer-rate-${o.id}`} className="font-display text-[38px] leading-none text-[#0b1f3a] mt-6">
        {o.rate_aer.toFixed(2)}<span className="text-[20px]">%</span>
        <span className="text-[14px] font-sans text-[#0b1f3a]/50 ml-2">{tr("p.a. AER")}</span>
      </p>

      <dl className="grid grid-cols-2 gap-3 mt-6 text-[13px]">
        <div><dt className="text-[#0b1f3a]/45 uppercase tracking-wide text-[11px]">{tr("Minimum deposit")}</dt><dd className="text-[#0b1f3a] mt-0.5">{fmtMin(o.min_deposit)}</dd></div>
        <div><dt className="text-[#0b1f3a]/45 uppercase tracking-wide text-[11px]">{tr("Currency")}</dt><dd className="text-[#0b1f3a] mt-0.5">{o.currency}</dd></div>
        <div className="col-span-2"><dt className="text-[#0b1f3a]/45 uppercase tracking-wide text-[11px]">{tr("Deposit protection")}</dt><dd className="text-[#0b1f3a] mt-0.5">{tr(o.deposit_protection)}</dd></div>
      </dl>

      <span data-testid={`offer-availability-${o.id}`} className={`self-start mt-5 text-[12px] rounded-full px-3 py-1 ring-1 ${a.cls}`}>{tr(a.label)}</span>

      <div className="mt-auto pt-6 flex items-center justify-between gap-3 border-t border-[#0b1f3a]/10">
        <span className="inline-flex items-center gap-1.5 text-[12px] text-[#0b1f3a]/50" data-testid={`offer-checked-${o.id}`}>
          <CalendarCheck size={14} /> {tr("Last checked")} {fmtDate(o.last_checked)}
        </span>
        <button onClick={() => onRequest(o)} data-testid={`offer-request-${o.id}`}
          className="inline-flex items-center gap-1.5 whitespace-nowrap text-[13px] font-semibold text-[#0b1f3a] hover:text-[#c2a15a] transition-colors">
          {tr("Request offer")} <ArrowRight size={15} className="transition-transform group-hover:translate-x-0.5" />
        </button>
      </div>
    </article>
  );
}
